import { CircularProgress, Backdrop as MuiBackdrop } from "@mui/material";
import React from "react";

const EntaBackdrop: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  return (
    <MuiBackdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={isOpen}
    >
      <CircularProgress color="inherit" />
    </MuiBackdrop>
  );
};

export default EntaBackdrop;
